import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=35eb031f&scoped=true&"
import script from "./Spin.vue?vue&type=script&lang=js&"
export * from "./Spin.vue?vue&type=script&lang=js&"
import style0 from "./Spin.vue?vue&type=style&index=0&id=35eb031f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb031f",
  null
  
)

export default component.exports